import { useRef } from "react";
import { Straighten } from "@mui/icons-material";
import { Fab, Tooltip } from "@mui/material";
import { ControlOptions } from "leaflet";
import { useTranslation } from "react-i18next";

import { MapControlBase } from "./MapControlBase";
import { useMeasuringMode } from "hooks/measuringHooks";
import RulerLine from "./RulerLine";

interface Props extends ControlOptions {}

export function RulerControl(props: Props) {
  const { ...controlProps } = props;
  const { t } = useTranslation();
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const { isMeasuring, setIsMeasuring } = useMeasuringMode();

  return (
    <MapControlBase {...controlProps}>
      <Tooltip title={t("label.ruler")} placement="left">
        <Fab
          size="small"
          variant="circular"
          ref={anchorEl}
          onClick={() => setIsMeasuring(!isMeasuring)}
          color={isMeasuring ? "primary" : "default"}
        >
          <Straighten />
        </Fab>
      </Tooltip>
      {isMeasuring && <RulerLine key={isMeasuring.toString()} />}
    </MapControlBase>
  );
}
